import React, { useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { ModuleAccordionGroup, LabelStringColumn, InputText } from "@loanbossinc/component-library";
import { CardPageLayout } from "component-lib/CardPageLayout";
import { GenericHeroCard } from "component-lib/GenericHeroCard";

import { actionCreators as integrationsActionCreators } from "../../../components/Admin/VendorIntegrations/vendorIntegrations.store";

import { VendorHeaderRow, VendorPropertyRow } from "./styles";

const EditDealIntegrations = props => {
  const {
    deal,
    history,
    companyIntegrations,
    company,
    vendorProperiesForDeal,
    getVendorIntegrationsForCompany,
    getVendorPropertiesIds,
    updateVendorPropertyIds
  } = props;

  const [isExpanded, setIsExpanded] = useState(false);
  const [vendorPropertyMappings, setVendorPropertyMappings] = useState(null);
  const [initialMappings, setInitialMappings] = useState(null);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);

  useEffect(() => {
    if (!companyIntegrations) {
      getVendorIntegrationsForCompany({ companyId: company.id });
    }
  }, [companyIntegrations]);

  useEffect(() => {
    if (!vendorProperiesForDeal) {
      getVendorPropertiesIds({ dealId: deal.id, companyId: company.id });
    }
  }, [vendorProperiesForDeal]);

  useEffect(() => {
    setIsExpanded(true);
  }, []);

  useEffect(() => {
    if (companyIntegrations && vendorProperiesForDeal) {
      const vendorsMappings = {};
      companyIntegrations.forEach(int => {
        vendorsMappings[`${int.vendorName}`] = {};
        deal.properties.forEach(dp => {
          const existingMapping = vendorProperiesForDeal.find(vp => vp.propertyId === dp.id && int.vendorId === vp.vendorId);
          vendorsMappings[`${int.vendorName}`][dp.id] = existingMapping ?
            { ...existingMapping } :
            { vendorPropertyId: "", vendorId: int.vendorId, propertyId: dp.id, companyId: company.id, dealId: deal.id, vendorName: int.vendorName };
        });
      });
      setVendorPropertyMappings(vendorsMappings);
      setInitialMappings(vendorsMappings);
    }
  }, [companyIntegrations, vendorProperiesForDeal]);

  const onInputChange = e => {
    if (isSaveDisabled) {
      setIsSaveDisabled(false);
    }
    const [vendorName, propertyId] = e.target.name.split("-");
    const updatedMappings = _.cloneDeep(vendorPropertyMappings);
    updatedMappings[vendorName][propertyId].vendorPropertyId = e.target.value;
    setVendorPropertyMappings(updatedMappings);
  };

  const rows = useMemo(() => {
    const rowsList = [];
    if (vendorPropertyMappings) {
      const getPropertyName = id => deal.properties.find(p => p.id === id).name;

      _.forOwn(vendorPropertyMappings, (mapping, vendor) => {
        rowsList.push(<VendorHeaderRow>{`${vendor} property ids`}</VendorHeaderRow>);
        _.forOwn(mapping, m => {
          rowsList.push(
            <VendorPropertyRow>
              <LabelStringColumn value={getPropertyName(m.propertyId)} />
              <InputText
                variant="filled"
                id={`${m.vendorName}-${m.propertyId}`}
                name={`${m.vendorName}-${m.propertyId}`}
                label={`${m.vendorName} Property ID`}
                onChange={onInputChange}
                value={m.vendorPropertyId}
                style={{ width: "280px" }}
              />
            </VendorPropertyRow>
          );
        });
      });
    }

    return rowsList;
  }, [vendorPropertyMappings]);

  const onSave = () => {
    const newMappings = [];
    _.forOwn(vendorPropertyMappings, vendor => {
      _.forOwn(vendor, mapping => {
        newMappings.push(_.omit(mapping, ["createdAt", "updatedAt"]));
      });
    });

    updateVendorPropertyIds({ data: newMappings });
    setIsSaveDisabled(true);
  };

  const renderBody = () => (
    <ModuleAccordionGroup
      shouldExpandAll={isExpanded}
      groups={[
        {
          title: "Integrations",
          key: "Integrations",
          isExpandable: true,
          isTitleGroup: false,
          sections: rows
        }
      ]}
    />
  );

  const heroCardButtons = [
    {
      label: "Save Changes",
      onClick: onSave,
      disabled: isSaveDisabled
    },
    {
      label: "Reset",
      onClick: () => {
        setVendorPropertyMappings(initialMappings);
        setIsSaveDisabled(true);
      }
    }
  ];

  return (
    <CardPageLayout
      {...props}
      isReversed
      bannerImageUrl={deal.imageLarge}
      cardComponent={<GenericHeroCard buttons={heroCardButtons} title={deal.name} deal={deal} backLabel="Deal Settings" history={history} />}
      bodyComponent={<div className="d-flex f-1 flex-column">{renderBody()}</div>}
    />
  );
};

const mapStateToProps = ({ vendorIntegrations }) => ({ ...vendorIntegrations });

const mapDispatchToProps = dispatch => bindActionCreators({ ...integrationsActionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EditDealIntegrations);
